import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const GreetingsComponet = () => {
  const AppType = useSelector((state) => state.uiReducers.appType);
  const [Greet, setGreet] = useState();
  const getSuitablegreeting = () => {
    const hour = Number(new Date().getHours());
    // console.log(hour);
    if (hour < 12) {
      setGreet("Good Morning");
      return;
    } else if (12 <= hour && hour < 17) {
      setGreet("Good Afternoon");
      return;
    } else if (17 <= hour && hour < 21) {
      setGreet("Good Evening");
      return;
    }
    return setGreet("Good Night");
  };
  useEffect(() => {
    const intervalId = setInterval(() => {
      getSuitablegreeting();
    }, 1000); // 1 hour
    return () => {
      clearInterval(intervalId);
    };
  }, []);
  return (
    <strong className={AppType === "Ecommerce" ? "text-org" : ""}>
      {Greet}
    </strong>
  );
};

export default GreetingsComponet;
